import { StylesConfig } from 'react-select';
import companyId from 'services/company_id';
import { ProfileData } from 'store/modules/profile_store/types';
import { IpRow } from './types';

export interface SelectOption {
  value: string;
  label: string;
}

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const CNPJ_MASK = '**.***.***/****-99';
export const MAX_LIST_ROWS = 10;

export const isFullName = (value: string) =>
  value
    .trim()
    .split(/\s+/)
    .filter((part) => part.length >= 2).length >= 2;

export const inputClass = (error?: string) => `form-control ${error ? 'is-invalid' : ''}`;

export const selectStyles = (hasError: boolean): StylesConfig<SelectOption, false> => ({
  control: (base) =>
    hasError ? { ...base, borderColor: '#dc3545', '&:hover': { borderColor: '#dc3545' } } : base,
});

export const optionLabel = (options: SelectOption[], value: string) =>
  options.find((option) => option.value === value)?.label || '';

export const nextRowId = (rows: Array<{ id: number }>) =>
  rows.reduce((max, row) => Math.max(max, row.id), 0) + 1;

export const emptyIpRow = (id: number): IpRow => ({
  id,
  ip: '',
  ip_versao: 'ipv4',
  tipo_hospedagem: '',
  ip_titular_cnpj: '',
  provedor_nuvem: '',
  ip_localizacao: '',
});

export const activeCompany = (profile: ProfileData) => {
  const loggedCompany = profile.company_data?.data;

  if (!profile.representant) return loggedCompany;

  const id = companyId(profile);
  return profile.represented?.find((company) => company.id === id) || loggedCompany;
};
